import skMessages from "../locales/sk_SK";

const skLang = {
  messages: {
    ...skMessages,
  },
  locale: "sk-SK",
};
export default skLang;
